// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__6pObN","button-large":"Button_button-large__HpJHG","button-small":"Button_button-small__IyX_t","button-medium":"Button_button-medium__kfaCc"};